import { Icon } from '@iconify/react';


const Error401 = () => {

  const RedirectToLogin = () => {
    window.location.href = '/auth/login';
  };

  return (
    <div className="tw-min-h-[100vh] tw-flex tw-items-center tw-justify-center tw-bg-[#f8f9fa] tw-p-[20px] [font-family:'Inter',_sans-serif] max-[768px]:tw-flex-col max-[768px]:tw-text-center error-page">
      <div className="max-[768px]:tw-mr-0 max-[768px]:tw-mb-[50px] max-[768px]:tw-p-[0_20px] tw-text-center tw-max-w-[400px] tw-mr-[50px] tw-bg-[white] tw-p-[40px] tw-rounded-[16px] tw-shadow-[0_4px_24px_rgba(0,_0,_0,_0.08)] tw-w-full error-content">
        <div className="tw-text-[120px] tw-font-bold tw-text-[#2563eb] tw-leading-[1] tw-mb-[24px] tw-animate-[float_6s_ease-in-out_infinite] max-[768px]:tw-text-[100px] error-number">401</div>
        <h1 className="tw-text-[32px] tw-text-[#1f2937] tw-mb-[16px] max-[768px]:tw-text-[28px] error-title">Session Expired</h1>
        <p className="tw-text-[16px] tw-text-[#6b7280] tw-mb-[32px] tw-leading-[1.6] error-description">
          Your session has expired or is no longer valid. Please log in again to continue using the application.
        </p>
        <div className="tw-flex tw-gap-[16px] tw-justify-center max-[768px]:tw-flex-col max-[768px]:tw-items-stretch error-actions">
          <button
            className={"tw-p-[12px_24px] tw-rounded-[8px] tw-text-[16px] tw-font-medium tw-flex tw-items-center tw-gap-[8px] tw-cursor-pointer [transition:all_0.3s_ease] tw-border-0 tw-bg-[#2563eb] tw-text-[white] [&:hover]:tw-bg-[#1d4ed8] [&:hover]:[transform:translateY(-2px)] max-[768px]:tw-justify-center btn-home"}
            onClick={RedirectToLogin}
          >
            <Icon icon="mdi:login" className="tw-text-[20px] home-icon" />
            Login Again
          </button>
        </div>
      </div>

    </div>
  );
};

export default Error401; 